
(function() {
  var result = { translations: { "zh-hk": { "i18n": { "duration": { "seconds": "{{ seconds }} \u79D2", "minutes": "{{ minutes }} \u5206\u9418", "hours": "{{ hours }} \u5C0F\u6642", "hoursAndMinutes": "{{ hours }} \u5C0F\u6642 {{ minutes }} \u5206\u9418", "days": "{{ days }} \u65E5", "shortForm": { "seconds": "{{ seconds }} \u79D2", "minutes": "{{ minutes }} \u5206", "hours": "{{ hours }} \u5C0F\u6642", "days": "{{ days }} \u65E5", "hoursAndMinutes": "{{ hours }} \u5C0F\u6642 {{ minutes }} \u5206" } }, "dateTime": { "quarterAndYear": "{{yearNumber}} \u5E74\u7B2C {{quarterNumber}} \u5B63 " }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "zh-hk": "static-7.1139"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1139",
    "ar-eg": "static-7.1139",
    "bg": "static-7.1139",
    "bn": "static-7.1139",
    "ca-es": "static-7.1139",
    "cs": "static-7.1139",
    "da": "static-7.1139",
    "de": "static-7.1139",
    "el": "static-7.1139",
    "en-gb": "static-7.1139",
    "en": "static-7.1139",
    "es-mx": "static-7.1139",
    "es": "static-7.1139",
    "et": "static-7.1139",
    "fi": "static-7.1139",
    "fr-ca": "static-7.1139",
    "fr": "static-7.1139",
    "he-il": "static-7.1139",
    "hi": "static-7.1139",
    "hr": "static-7.1139",
    "hu": "static-7.1139",
    "id": "static-7.1139",
    "it": "static-7.1139",
    "ja": "static-7.1139",
    "ko": "static-7.1139",
    "lt": "static-7.1139",
    "ms": "static-7.1139",
    "nl": "static-7.1139",
    "no": "static-7.1139",
    "pl": "static-7.1139",
    "pt-br": "static-7.1139",
    "pt-pt": "static-7.1139",
    "ro": "static-7.1139",
    "ru": "static-7.1139",
    "sk": "static-7.1139",
    "sl": "static-7.1139",
    "sv": "static-7.1139",
    "th": "static-7.1139",
    "tl": "static-7.1139",
    "tr": "static-7.1139",
    "uk": "static-7.1139",
    "vi": "static-7.1139",
    "x-pseudo": "static-7.1139",
    "zh-cn": "static-7.1139",
    "zh-hk": "static-7.1139",
    "zh-tw": "static-7.1139"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:zh-hk', {version: 'static-7.1139'}); }
})();


